/*
  * Functions to enter data into the progress circle for the data usage
  */

/*
* @param {object} queued_plan_card - The queued bundle card HTML element
  * @param {object} esim_info - The BundleInformation object
* */
function insertDataUsageProgressCircle(progressCircle, bundleUsage, sizeOfAGigabyte = 1000000000) {

    let circularProgress = progressCircle.querySelector('.circular-progress');

    let initialQuantity = bundleUsage.initialQuantity / sizeOfAGigabyte;
    let remainingQuantity = bundleUsage.remainingQuantity / sizeOfAGigabyte;

    let unit = window.esimCardStrings.gigabyte;

    if (bundleUsage.unlimited) {
      remainingQuantity = initialQuantity
      progressCircle.querySelector(".infinityIcon").classList.remove('hidden')
      progressCircle.querySelector("#bundle-progress-value").innerText = "";
      progressCircle.querySelector("#bundle-progress-sub-value").innerText = window.esimCardStrings.unlimitedBundle;
    } else {
      progressCircle.querySelector("#bundle-progress-value").innerText = remainingQuantity.toFixed(1) + unit;
      progressCircle.querySelector("#bundle-progress-sub-value").innerText = window.esimCardStrings.ofCapitalPrefix + initialQuantity.toFixed(1) + unit;
    }

    let usedData = initialQuantity - remainingQuantity;

    let progressEndValue = 100 - (usedData.toFixed(1) / initialQuantity.toFixed(1)) * 100;
    circularProgress.style.background = `conic-gradient(rgb(var(--color-base-accent-1)) ${progressEndValue}%, rgb(var(--color-base-accent-2)) 0deg)`;
  }
